/**
 * 学习乐园 · 连连看题材包：名著配作者（lianliankan/pack-mingzhu.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：书连作者（「《西游记》」连「吴承恩」）。中外各收一半：
 * 四大名著与文言短篇、近现代散文小说，加上童话与儿童文学里最常见的
 * 外国经典——都是课本与书单上的「熟面孔」。note 讲这本书是谁写的、
 * 讲的是什么，配上之后顺口就是一句书目。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.mingzhu = {
    id: 'mingzhu',
    name: '名著配作者',
    hint: '这本书是谁写的',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '《西游记》', r: '吴承恩', note: '师徒四人西天取经' },
      { l: '《水浒传》', r: '施耐庵', note: '一百单八将聚义梁山' },
      { l: '《三国演义》', r: '罗贯中', note: '魏蜀吴争霸，七分实三分虚' },
      { l: '《红楼梦》', r: '曹雪芹', note: '大观园里的兴衰，古典小说之巅' },
      { l: '《聊斋志异》', r: '蒲松龄', note: '写狐仙花妖的文言短篇' },
      { l: '《朝花夕拾》', r: '鲁迅', note: '回忆童年与故乡的散文集' },
      { l: '《骆驼祥子》', r: '老舍', note: '北京人力车夫的故事' },
      { l: '《繁星·春水》', r: '冰心', note: '写母爱、童真与自然的短诗' },
      { l: '《城南旧事》', r: '林海音', note: '小英子眼里的老北京' },
      { l: '《安徒生童话》', r: '安徒生', note: '卖火柴的小女孩、丑小鸭' },
      { l: '《格林童话》', r: '格林兄弟', note: '白雪公主、灰姑娘的故乡' },
      { l: '《小王子》', r: '圣埃克苏佩里', note: 'B-612 星球上的那朵玫瑰' },
      { l: '《夏洛的网》', r: 'E.B.怀特', note: '蜘蛛夏洛救小猪威尔伯' },
      { l: '《汤姆·索亚历险记》', r: '马克·吐温', note: '密西西比河边的顽童' },
      { l: '《鲁滨逊漂流记》', r: '笛福', note: '荒岛求生二十八年' },
      { l: '《海底两万里》', r: '凡尔纳', note: '鹦鹉螺号潜水艇环游世界' },
      { l: '《昆虫记》', r: '法布尔', note: '蝉和蟋蟀的科学观察日记' },
      { l: '《爱的教育》', r: '亚米契斯', note: '小学生安利柯的一学年日记' },
      { l: '《儒林外史》', r: '吴敬梓', note: '范进中举就出自这里' },
      { l: '《呼兰河传》', r: '萧红', note: '祖父的园子，东北小城' },
      { l: '《草房子》', r: '曹文轩', note: '油麻地小学的桑桑' },
      { l: '《窗边的小豆豆》', r: '黑柳彻子', note: '巴学园的电车教室' },
      { l: '《爱丽丝漫游奇境》', r: '卡罗尔', note: '掉进兔子洞的奇遇' },
      { l: '《木偶奇遇记》', r: '科洛迪', note: '说谎鼻子会变长的皮诺曹' },
      { l: '《长袜子皮皮》', r: '林格伦', note: '力气大得能举起马的小姑娘' },
      { l: '《假如给我三天光明》', r: '海伦·凯勒', note: '盲聋作家的光明心愿' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
